import React from 'react';
import HeroIntroSection from './HeroIntroSection';
import MonthlyRankingSection from './MonthlyRankingSection';

const HeroAndRankingSection = ({
  monthLabel,
  monthlyRankings,
  onStart,
  onOpenRankings,
  onOpenRankingUser,
}) => {
  return (
    <section className="grid grid-cols-1 lg:grid-cols-[1.35fr_0.65fr] gap-4 md:gap-6 mb-8 md:mb-10">
      <HeroIntroSection onStart={onStart} />
      <MonthlyRankingSection
        monthLabel={monthLabel}
        entries={monthlyRankings}
        onOpenAll={onOpenRankings}
        onOpenUser={onOpenRankingUser}
      />
    </section>
  );
};

export default HeroAndRankingSection;
